import Gleap from 'gleap';
import {IAppSettings} from '../../model';
import {notifications} from "../notifications-service";

export class GleapService {
  private static instance: GleapService;
  private initialized = false;

  private constructor() { }

  public static getInstance(): GleapService {
    if (!GleapService.instance) {
      GleapService.instance = new GleapService();
    }
    return GleapService.instance;
  }

  public initGleap = (settings: IAppSettings): void => {
    if (this.initialized) {
      return;
    }

    const gleapKey = settings.keys?.gleapKey;
    const hostname = window.document.location.hostname;
    const envMode = hostname === 'demo.customer-management' ? 'demo' : hostname.includes('dev.customer-management') ? 'dev' : 'prod';

    if (gleapKey) {
      Gleap.initialize(gleapKey);
      Gleap.showFeedbackButton(true);
      this.initialized = true;

      if (envMode !== 'prod') {
        Gleap.setEnvironment('dev');
      }
    }
  };

  public identifyGleapUser = (settings: IAppSettings, username: string, grmUserId: string, email: string): void => {
    const gleapKey = settings.keys?.gleapKey;
    if (!gleapKey) {
      return;
    }

    const baseUrl = settings.paths?.baseUrl;
    Gleap.clearIdentity();
    Gleap.identify(grmUserId, {
      name: username,
      email: email,
      companyName: baseUrl,
    });
  };

  public clearAndCloseGleap = (settings: IAppSettings): void => {
    const gleapKey = settings.keys?.gleapKey;
    if (!gleapKey) {
      return;
    }

    Gleap.clearIdentity();
    Gleap.close();
    Gleap.destroy();
    this.initialized = false;
  };

  public isInitialized = (): boolean => {
    return this.initialized;
  };

  public startSnapshotForm(settings: IAppSettings, customerName?: string): Promise<boolean> {
    if (!this.initialized) {
      return Promise.resolve(false);
    }

    Gleap.preFillForm({
      "serviceName": "cameraSetup",
      "customerName": customerName
    });

    const formId = settings.gleap?.requestSnapshotActivatingFormId || '';

    Gleap.startClassicForm(formId);
    return Promise.resolve(true);
  }

  public getTicketsByUserId = async (
      userId: string,
      settings: IAppSettings,
  ): Promise<any> => {

    const GLEAP_API_URL = 'https://api.gleap.io/v3/tickets/by-session-query';
    const USER_EMAIL = userId;
    const API_TOKEN = settings.gleap?.apiToken || '';
    const PROJECT_ID = settings.gleap?.projectId || '';

    try {
      const url = `${GLEAP_API_URL}?userId=${encodeURIComponent(USER_EMAIL)}`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${API_TOKEN}`,
          'project': PROJECT_ID,
          'Content-Type': 'application/json'
        }
      });

      return await response.json();
    } catch (err) {
      console.error("err:", err);
      notifications.error('Failed to fetch Gleap tickets.');
    }
  };

  public getTicketInfoById = async (
      ticketId: string,
      settings: IAppSettings,
  ): Promise<any> => {

    const GLEAP_API_URL = `https://api.gleap.io/v3/tickets/${ticketId}`;
    const API_TOKEN = settings.gleap?.apiToken || '';
    const PROJECT_ID = settings.gleap?.projectId || '';

    try {

      const response = await fetch(GLEAP_API_URL, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${API_TOKEN}`,
          'project': PROJECT_ID,
          'Content-Type': 'application/json'
        }
      });

      return await response.json();
    } catch (err) {
      console.error("err:", err);
      notifications.error('Failed to fetch Gleap ticket info.');
    }
  };
}

export const gleapService = GleapService.getInstance();
